import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CountUp from 'countup.js';

import FilterTitle from './FilterTitle';

import './TotalResults.scss';

const COUNT_UP_FROM = 0;
const COUNT_UP_DECIMALS = 0;
const COUNT_UP_DURATION = 0.5;
const COUNT_UP_CONFIG = {
  useEasing: true,
  useGrouping: false,
  separator: ',',
  decimal: '.',
  prefix: '',
  suffix: ''
};

class TotalResults extends PureComponent {
  componentDidMount() {
    this.initCountUp();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.totalResults !== nextProps.totalResults) {
      this.filterResultsCounter.update(nextProps.totalResults);
    }
  }

  filterHeaderResultsRef = React.createRef();

  initCountUp = () => {
    const element = this.filterHeaderResultsRef.current;
    const to = this.props.totalResults;

    this.filterResultsCounter = new CountUp(
      element,
      COUNT_UP_FROM,
      to,
      COUNT_UP_DECIMALS,
      COUNT_UP_DURATION,
      COUNT_UP_CONFIG
    );

    this.filterResultsCounter.start();
  };

  render() {
    return (
      <h1 className="total-results">
        <span
          className="total-results__number"
          ref={this.filterHeaderResultsRef}
        >
          {this.props.totalResults}
        </span>
        <FilterTitle
          types={this.props.types}
          citySlug={this.props.citySlug}
          currentNeighborhood={this.props.currentNeighborhood}
        />
      </h1>
    );
  }
}

TotalResults.propTypes = {
  totalResults: PropTypes.number.isRequired,
  ...FilterTitle.propTypes
};

export default TotalResults;
